export default __webpack_public_path__ + "static/media/file-document-box-check-outline.2c931e0e.svg";